import createCategoriaCotizacionForm from './createCategoriaCotizacionFormModel';
const {
  formField: {
    // DATOS PARAMETROS 
    name,
    description
  } 
} = createCategoriaCotizacionForm;


export default {

  [name.name]: '',
  [description.name]: '',
};

